import React from "react";
import {
  Accordion, AccordionContent, AccordionItem, AccordionTrigger,
} from "../components/ui/accordion";

const FAQS = [
  { q: "What is Zelo?", a: "Zelo is a platform that offers verified, rent-generating pre-leased commercial properties." },
  { q: "What is a Pre-Leased Property?", a: "A property already rented out to a tenant — meaning rental income starts from Day 1." },
  { q: "Who are the typical tenants?", a: "Top brands — Banks, Jewelers, QSRs, Retail Chains, Corporate offices and more." },
  { q: "How soon can I start earning rental income?", a: "From the very first day of ownership transfer." },
  { q: "Will I get a sale deed in my name?", a: "Yes. You receive full legal ownership registered in your name." },
  { q: "Is documentation and due diligence already done?", a: "Yes. Lease agreements, approvals, and tenant checks are all in place." },
  { q: "Can NRIs invest in Zelo properties?", a: "Absolutely. NRIs invest seamlessly and receive rent in their Indian bank accounts." },
  { q: "Are these properties bank-financeable?", a: "Yes. All pre-leased properties are LRD-eligible up to 70% with leading banks." },
];

export default function FAQ() {
  return (
    <div className="container-zelo py-16 md:py-24" data-testid="faq-page">
      <div className="max-w-3xl">
        <div className="label-tiny text-brand">FAQs</div>
        <h1 className="font-heading text-4xl md:text-6xl font-medium tracking-tight mt-3 text-balance">Know everything about Zelo.</h1>
        <p className="mt-5 text-neutral-500 text-lg">The process. The properties. How to start earning rent.</p>
      </div>
      <div className="mt-10 grid grid-cols-1 lg:grid-cols-12 gap-10 max-w-5xl">
        <div className="lg:col-span-8">
          <Accordion type="single" collapsible className="space-y-3">
            {FAQS.map((f, i) => (
              <AccordionItem key={i} value={`f-${i}`} className="rounded-2xl border border-neutral-200 bg-white px-5">
                <AccordionTrigger className="text-left font-heading text-base md:text-lg font-medium" data-testid={`faq-q-${i}`}>{f.q}</AccordionTrigger>
                <AccordionContent className="text-neutral-600 leading-relaxed">{f.a}</AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
        <div className="lg:col-span-4">
          <div className="p-6 rounded-2xl border border-neutral-200 bg-white sticky top-24" data-testid="faq-contact-card">
            <div className="text-sm font-semibold text-neutral-900">Can't find an answer?</div>
            <div className="text-sm text-neutral-500 mt-1">Reach Aman Nainani — Chief Sales Officer.</div>
            <div className="mt-4 space-y-2 text-sm">
              <a href="tel:+918758115155" className="block text-brand font-medium hover:underline">+91 87581 15155</a>
              <a href="mailto:aman@zelolease.com" className="block text-brand font-medium hover:underline">aman@zelolease.com</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
